import styled from 'styled-components'
import { breakPoints, breakPointsCss, colors } from '../utils/config'
import { Button, Icon } from '@bm-js/atlascloud-ui'
import { LucideIconName, parseDateTime, UserBM } from '@bm-js/atlascloud-shared'
import { useMemo } from 'react'
import { useUser } from '../utils/hooks'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

const StyledUserCard = styled.div`
  padding: 0.5rem;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  position: relative;
  align-items: center;
  &:after {
    position: absolute;
    content: '';
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 1px;
    background: ${colors.blackAlpla300};
  }
  .user-col {
    p {
      color: ${colors.gray700};
    }
  }
  ${breakPointsCss.tablet} {
    grid-template-columns: 1fr auto;
    .last-login {
      display: none;
    }
  }
`

type Props = {
  user: UserBM
  deleteUser: () => void
  editUserInit: () => void
}

const UserCard = ({ user, deleteUser, editUserInit }: Props) => {
  const { tr } = useTr()
  const currentUser = useUser()

  const tablet = window.innerWidth < breakPoints.tablet

  const isYou = useMemo(() => {
    return currentUser?._id === user._id
  }, [currentUser, user._id])

  return (
    <StyledUserCard>
      <div className='user-col'>
        <p className='m0  b'>
          {user.fullName}
          {isYou && ` (${tr(TrKey.usersYou)})`}
        </p>
        <p className='m0 '>{user.email}</p>
      </div>
      <div className='user-col last-login'>
        <p className='m0 b'>{tr(TrKey.usersLastLogin)}</p>
        <p className='m0'>{parseDateTime(user.lastLoggedIn)}</p>
      </div>
      <div className='user-col jsfe gap1 flex'>
        <Button
          disabled={isYou}
          onClick={editUserInit}
          withIcon={tablet}
          className='text-white'
        >
          {tablet ? (
            <Icon name={LucideIconName.Pen} className='size-5' />
          ) : (
            tr(TrKey.edit)
          )}
        </Button>
        <Button
          disabled={isYou}
          danger
          onClick={deleteUser}
          withIcon={tablet}
          className='text-white'
        >
          {tablet ? (
            <Icon name={LucideIconName.Trash2} className='size-5' />
          ) : (
            tr(TrKey.delete)
          )}
        </Button>
      </div>
    </StyledUserCard>
  )
}

export default UserCard
